export var developmentConfig = {
    authApiUrl: 'https://preprod.auth.move.tomtom.com',
    legolandApiUrl: 'https://preprod.api.move.tomtom.com',
    legolandUiUrl: 'https://preprod.move.tomtom.com',
};
//# sourceMappingURL=developmentConfig.js.map